module.exports = __webpack_public_path__ + "img/product3.b0e766e3.png";